import { render } from "./SettingsPanel.vue?vue&type=template&id=d5e8edc8&scoped=true"
import script from "./SettingsPanel.vue?vue&type=script&lang=js"
export * from "./SettingsPanel.vue?vue&type=script&lang=js"

import "./SettingsPanel.vue?vue&type=style&index=0&id=d5e8edc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5e8edc8"]])

export default __exports__